import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import { History, ChevronRight } from 'lucide-react';

export default function AdminLogsPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { (async () => { try { const { data } = await api.get('/admin/logs'); setLogs(data.logs); } catch (e) {} finally { setLoading(false); } })(); }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6 flex items-center gap-2"><History size={24} className="text-yellow-400" />Log Azioni</h1>
      {loading ? <div className="flex justify-center py-16"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400" /></div> : (
        <div className="space-y-2">{logs.map(l => (
          <div key={l.id} className="card-dark p-3 flex items-center gap-3">
            <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-xs text-gray-300 font-bold">{l.first_name?.[0]}{l.last_name?.[0]}</div>
            <div className="flex-1"><p className="text-sm text-white"><span className="font-medium">{l.first_name} {l.last_name}</span> <span className="text-yellow-400">{l.action}</span> {l.entity_type && <span className="text-gray-400">su {l.entity_type} #{l.entity_id}</span>}</p><p className="text-[10px] text-gray-500">{new Date(l.created_at).toLocaleString('it-IT')}</p></div>
          </div>
        ))}</div>
      )}
    </div>
  );
}
